module.exports = __webpack_public_path__ + "img/document.3e85034d.jpg";